export default __webpack_public_path__ + "static/homepage-banner-ddb0b5948753974f49f02a09a20a101d.webp";